import { ForwardRefExoticComponent, SVGProps } from 'react'

import { OnlineTravelAgency } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  IconAirbnbRectangle,
  IconAvantstayRectangle,
  IconBookingComRectangle,
  IconExpediaRectangle,
  IconGoogleTravelRectangle,
  IconHomesAndVillasRectangle,
  IconHomeToGoRectangle,
  IconHopperRectangle,
  IconHotelTonightRectangle,
  IconMarriottRectangle,
  IconQuintessRectangle,
  IconTravelStaytionRectangle,
  IconTripAdvisorRectangle,
  IconVacationRenterRectangle,
  IconVRBORectangle,
  IconWhimstayRectangle,
} from '@avantstay/backoffice-vectors'

import { BadgeColors, BadgeColorsProps } from '../components/Badge'

export const onlineTravelAgencyLabel: Record<string, string> = {
  [OnlineTravelAgency.acqDirect]: 'ACQ Direct',
  [OnlineTravelAgency.airbnb]: 'Airbnb',
  [OnlineTravelAgency.blueGround]: 'Blueground',
  [OnlineTravelAgency.bnbFinder]: 'Savvy-bnbfinder',
  [OnlineTravelAgency.bonotel]: 'Bonotel',
  [OnlineTravelAgency.bookingCom]: 'Booking.com',
  [OnlineTravelAgency.capitalOne]: 'Capital One',
  [OnlineTravelAgency.direct]: 'Direct',
  [OnlineTravelAgency.expedia]: 'Expedia',
  [OnlineTravelAgency.google]: 'Google',
  [OnlineTravelAgency.googleTravel]: 'Google Travel',
  [OnlineTravelAgency.homesAndVillas]: 'Homes & Villas',
  [OnlineTravelAgency.homeToGo]: 'HomeToGo',
  [OnlineTravelAgency.hopper]: 'Hopper',
  [OnlineTravelAgency.hotelTonight]: 'HotelTonight',
  [OnlineTravelAgency.maimonGroup]: 'Maimon Group',
  [OnlineTravelAgency.marriott]: 'Marriott',
  [OnlineTravelAgency.quintess]: 'Quintess',
  [OnlineTravelAgency.rentalsUnited]: 'Rentals United',
  [OnlineTravelAgency.stayHvn]: 'Stay HVN',
  [OnlineTravelAgency.staySense]: 'StaySense',
  [OnlineTravelAgency.topVillas]: 'Top Villas',
  [OnlineTravelAgency.travelStaytion]: 'TravelStaytion',
  [OnlineTravelAgency.tripAdvisor]: 'Trip Advisor',
  [OnlineTravelAgency.vacationRenter]: 'VacationRenter',
  [OnlineTravelAgency.vrbo]: 'VRBO',
  [OnlineTravelAgency.wander]: 'Wander',
  [OnlineTravelAgency.whimstay]: 'Whimstay',
  [OnlineTravelAgency.yieldPlanet]: 'Yield Planet',
}

export const badgeColorByOnlineTravelAgency: Record<string, BadgeColorsProps> = {
  [OnlineTravelAgency.airbnb]: BadgeColors.channelAirbnb,
  [OnlineTravelAgency.direct]: BadgeColors.channelWebsite,
  [OnlineTravelAgency.rentalsUnited]: BadgeColors.channelRentalsUnited,
  [OnlineTravelAgency.vrbo]: BadgeColors.channelVRBO,
}

export const iconByOTA: Record<string, ForwardRefExoticComponent<SVGProps<SVGSVGElement>>> = {
  [OnlineTravelAgency.airbnb]: IconAirbnbRectangle,
  [OnlineTravelAgency.bookingCom]: IconBookingComRectangle,
  [OnlineTravelAgency.direct]: IconAvantstayRectangle,
  [OnlineTravelAgency.expedia]: IconExpediaRectangle,
  [OnlineTravelAgency.googleTravel]: IconGoogleTravelRectangle,
  [OnlineTravelAgency.homeToGo]: IconHomeToGoRectangle,
  [OnlineTravelAgency.homesAndVillas]: IconHomesAndVillasRectangle,
  [OnlineTravelAgency.hopper]: IconHopperRectangle,
  [OnlineTravelAgency.hotelTonight]: IconHotelTonightRectangle,
  [OnlineTravelAgency.marriott]: IconMarriottRectangle,
  [OnlineTravelAgency.quintess]: IconQuintessRectangle,
  [OnlineTravelAgency.travelStaytion]: IconTravelStaytionRectangle,
  [OnlineTravelAgency.tripAdvisor]: IconTripAdvisorRectangle,
  [OnlineTravelAgency.vacationRenter]: IconVacationRenterRectangle,
  [OnlineTravelAgency.vrbo]: IconVRBORectangle,
  [OnlineTravelAgency.whimstay]: IconWhimstayRectangle,
}
